import { flexRowBetween, flexRowCenterCenter } from '../../../common/styles/flex';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import { CONTROLS_BAR_HEIGHT } from '../../../common/utils/common.constants';

interface StylesObject {
  controlsBarStyle: { [key: string]: any };
  rightControlsStyle: { [key: string]: any };
  leftControlsStyle: { [key: string]: any };
}

const controlsBar = {
  ...flexRowBetween,
  alignItem: 'center',
  width: '100%',
  opacity: 1,
  backdropFilter: 'blur(3px)',
  webkitBackdropFilter: 'blur(3px)',
  backgroundColor: SITE_VARIABLES.COLORS.GRAY,
  pointerEvents: 'auto',
  height: CONTROLS_BAR_HEIGHT,
  hide: {
    opacity: 0,
  },
};

const rightControls = {
  ...flexRowCenterCenter,
};
const leftControls = {
  ...flexRowCenterCenter,
};

export const getControlsBarStyleObject = (isControlsBarVisible: boolean): StylesObject => ({
  controlsBarStyle: [
    controlsBar,
    !isControlsBarVisible && controlsBar.hide,
  ],
  rightControlsStyle: {
    ...rightControls,
  },
  leftControlsStyle: {
    ...leftControls,
  },
});
